module.exports = __webpack_public_path__ + "static/media/embroidery.fb63b278.jpg";